module.exports = __webpack_public_path__ + "img/mirror29.e4cf5832.jpg";